const ERROR = { error: true };

const LENGTH_CC_NUMBER = 6;

export { ERROR, LENGTH_CC_NUMBER };
